import { render, staticRenderFns } from "./FeedbackPage.vue?vue&type=template&id=fbf5a752&scoped=true&"
import script from "./FeedbackPage.vue?vue&type=script&lang=js&"
export * from "./FeedbackPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf5a752",
  null
  
)

export default component.exports